module.exports = __webpack_public_path__ + "static/media/address-book.4d83e134.svg";